// @ vendor
const Immutable = require('immutable');

// @ constants
const actionTypes = require('../../constants/actionTypes');

function setInitialState() {
    return Immutable.fromJS({
        valid: false,
        isDisclaimerChecked: false,
        hasSignaturePattern: true,
        loadingCalculator: false,
        validFromCalculator: false,
        originFund: false,
        errorFlags: {
            disclaimer: false,
        },
        allDocumentsReads: false,
        allDocumentsReadsDirty: false,
    });
}

function validateStep(step) {
    const isDisclaimerChecked = step.get('isDisclaimerChecked');
    const allDocumentsReadsValid = step.get('allDocumentsReads');
    const valid = isDisclaimerChecked;
    return step.merge({
        valid: valid,
        errorFlags: {
            disclaimer: !isDisclaimerChecked,
        },
        loading: false,
        allDocumentsReadsDirty: !allDocumentsReadsValid,
    });
}

const setChangeDisclaimer = (step, value) => {
    const allDocumentsReadsValid = step.get('allDocumentsReads');

    if (allDocumentsReadsValid) {
        return step.merge({
            isDisclaimerChecked: value,
            errorFlags: {
                disclaimer: false,
            },
        });
    }

    return step.merge({
        errorFlags: {
            disclaimer: true,
        },
        allDocumentsReadsDirty: true,
    });
};

function cmWalletBuyStep2(state = setInitialState(), action) {
    switch (action.type) {
        case actionTypes.CM_FROM_FUNDS_VALIDATE_STEP:
        case actionTypes.CM_TRANSFER_MONEY_VALIDATE_STEP:
        case actionTypes.CM_VALIDATE_STEP:
            return validateStep(state);
        case actionTypes.CM_LEGAL_DISCLAIMER_CHANGED:
            return setChangeDisclaimer(state, action.payload.value);
        case actionTypes.CM_VALIDATE_ALL_DOCUMENTS_READS_DIRTY:
            return state.merge({
                allDocumentsReads: !action.payload.notAllRead,
            });
        case actionTypes.CM_RUN_CALCULATOR_SERVICE_REQUEST:
            return state.set('loadingCalculator', true);
        case actionTypes.CM_RUN_CALCULATOR_SERVICE_SUCCESS:
            return state.merge({
                validFromCalculator: true,
                loadingCalculator: false,
                originFund: action.payload.data, //info needed for validation step2 to 3
            });
        case actionTypes.CM_RESET_STEP:
            return setInitialState();
        case actionTypes.CM_RUN_CALCULATOR_SERVICE_FAILURE:
            return state.merge({
                validFromCalculator: false,
                loadingCalculator: false,
            });
        case actionTypes.CM_SHOW_MESSAGE_ERROR_CHECK:
            return state.merge({
                isDisclaimerChecked: !action.payload,
                errorFlags: {
                    disclaimer: action.payload,
                },
            });
        case actionTypes.CM_CHANGE_CHECK:
            return state.merge({
                isDisclaimerChecked: action.payload,
                errorFlags: {
                    disclaimer: !action.payload,
                },
            });
        default:
            return state;
    }
}

module.exports = cmWalletBuyStep2;
